import { endOfDay, lastDayOfMonth } from 'date-fns';
import { parseCardValidity } from '@src/common';

export const isCardExpired = (validity: string, ref: Date): boolean => {
  const lastValidInstant = endOfDay(lastDayOfMonth(parseCardValidity(validity)));

  return lastValidInstant.getTime() < ref.getTime();
};
